(() => {
  const roots = document.querySelectorAll("[data-dtfs-free-sample]")

  const identityLabels = {
    "custom-apparel": "We make custom apparel for customers",
    "apparel-brand": "We run an apparel brand",
    "apparel-reseller": "We resell apparel or merchandise",
    "promotional-products": "We sell promotional products",
    other: "Something else"
  }

  const experienceLabels = {
    experienced: "Has pressed DTF before",
    new: "Has not pressed DTF yet"
  }

  const volumeLabels = {
    "under-25": "Under 25",
    "25-99": "25–99",
    "100-249": "100–249",
    "250-plus": "250+"
  }

  const placementPresets = {
    "small-logo": {
      label: "Small logo or sleeve",
      size: "3″ × 3″",
      instruction: "Fit artwork within 3 in × 3 in; preserve proportions",
      preview: { x: 17, y: 28, width: 9, height: 9, transform: "rotate(30 21.5 32.5)" }
    },
    "left-chest": {
      label: "Left chest",
      size: "4″ × 4″",
      instruction: "Fit artwork within 4 in × 4 in; preserve proportions",
      preview: { x: 68, y: 32, width: 10.5, height: 9.5, transform: "" }
    },
    "center-chest": {
      label: "Center chest or youth front",
      size: "8″ × 8″",
      instruction: "Fit artwork within 8 in × 8 in; preserve proportions",
      preview: { x: 49.5, y: 34, width: 21, height: 18.5, transform: "" }
    },
    "full-front": {
      label: "Adult full front",
      size: "11″ × 11″",
      instruction: "Fit artwork within 11 in × 11 in; preserve proportions",
      preview: { x: 45.5, y: 36, width: 29, height: 25.5, transform: "" }
    },
    "full-back": {
      label: "Adult full back",
      size: "12″ × 17″",
      instruction: "Fit artwork within 12 in × 17 in; preserve proportions",
      preview: { x: 44, y: 32, width: 32, height: 39.5, transform: "" }
    }
  }

  const goalSets = {
    experienced: {
      heading: "What do you want to compare?",
      support: "",
      options: [
        ["print-quality", "Print quality"],
        ["color-detail", "Color & detail"],
        ["press-peel", "Press & peel"],
        ["consistency", "Consistency"]
      ]
    },
    new: {
      heading: "What do you want to test?",
      support: "",
      options: [
        ["look-feel", "Look & feel"],
        ["color-detail", "Color & detail"],
        ["press-peel", "Pressing"],
        ["project-fit", "Project fit"]
      ]
    }
  }

  const proofBridges = {
    default: {
      label: "Easy Order, fast shipping, made our Christmas",
      quote: "Easy to upload artwork, arrived less than a week later, the color was bright, and transfer easy. Will definitely order again!",
      reviewer: "Carmen F.",
      meta: "Verified DTFSheet customer",
      image: "https://review-images.judgeme.com/dtfsheet-com/1703608824__img_0360__original.jpeg?quality=80&width=1024",
      alt: "Family wearing matching white Christmas shirts made with DTFSheet transfers"
    },
    "print-quality": {
      label: "My only go to",
      quote: "Love, love, love DTFsheet!! Fastest service around. Fantastic prices, beautiful clear prints and so easy to use. Will not use anyone else.",
      reviewer: "Christie C.",
      meta: "Verified DTFSheet customer",
      image: "https://review-images.judgeme.com/dtfsheet-com/1704223015__img_0241__original.jpeg?quality=80&width=1024",
      imageCrop: "face-below-eyes",
      alt: "Customer wearing a gray shirt with a large crisp multicolor transfer"
    },
    "color-detail": {
      label: "Great detail and fast delivery",
      quote: "I needed some small images done and I have done screen printing, there’s no way I could get the detail I needed. Ordered one day showed up two days later. I tried a different company with the exact same graphic file and they did not have near as clean of an image as I got from DTFsheets.",
      reviewer: "Patric N.",
      meta: "Verified DTFSheet customer",
      image: "https://review-images.judgeme.com/dtfsheet-com/1714772252__img_5048__original.jpeg?quality=80&width=1024",
      alt: "Customer garment showing fine detail in a DTFSheet transfer"
    },
    "press-peel": {
      label: "Exceeded expectations",
      quote: "This is the second company I tried for custom HTV of my procreate artwork. I am blown away - it’s beautiful and amazing quality, shipped nicely, easy to press w a cricut iron and got here fast! I’ve already ordered 3 more designs and cannot wait to get them!",
      reviewer: "Robyn R.",
      meta: "Verified DTFSheet customer",
      image: "https://review-images.judgeme.com/dtfsheet-com/1714586219__img_9775__original.jpeg?quality=80&width=1024",
      alt: "Customer garment pressed with a detailed DTFSheet transfer"
    },
    consistency: {
      label: "custom heat transfer rolls",
      quote: "i needed 300 different transfers for a graduation event, after emailing them with the order process, they delivered all 300 of the transfers in 2 days, shipping them out the same day as promised. i couldn’t go without leaving a positive review. the transfers came in 2 rolls and the print quality was very nice. recommended 👍",
      reviewer: "David C.",
      meta: "Verified DTFSheet customer",
      image: "https://review-images.judgeme.com/dtfsheet-com/1688970579__09c30286-3231-4ce3-9ffe-c2fe9279aefe__original.jpeg?quality=80&width=1024",
      alt: "Customer production order made from DTFSheet transfer rolls"
    },
    "look-feel": {
      label: "Beyond pleased with this product!",
      quote: "I needed logos for shirts that wouldn't break the bank. I figured I'd give DTFsheet a shot. Shipping was fast as lightning- ordered on the 7th arrived on the 9th. The finished product is soft, not tacky and moves with the fabric. I will be returning 100%. I applied with a hot iron and am very pleased!",
      reviewer: "T.C.",
      meta: "Verified DTFSheet customer",
      image: "https://review-images.judgeme.com/dtfsheet-com/1707523955__inbound2819888972427257552__original.jpg?quality=80&width=1024",
      alt: "Customer shirt showing a soft DTFSheet logo transfer"
    },
    "project-fit": {
      label: "Absolutely LOVE these transfers",
      quote: "As a first time \"shirt presser\", I honestly didn't know what I was doing? DTFSheet made it SO EASY with the Custom Gang Sheet Tool and transfers! Our YouTube Logo turned out amazing and everyone loved our new \"merch\" at the meet up! Thank You DTFSheet! Logging in to order more!",
      reviewer: "Tara W.",
      meta: "Verified DTFSheet customer",
      image: "https://review-images.judgeme.com/dtfsheet-com/1715443836__whiterockhomesteadfanart-0111__original.png?quality=80&width=1024",
      alt: "Customer artwork used for a first DTFSheet merchandise project"
    }
  }

  const stepOrder = ["experience", "identity", "volume", "goal", "upload", "placement", "offer"]
  const progressByStep = {
    experience: 0.5,
    identity: 0.7,
    volume: 0.9,
    goal: 0.91,
    upload: 0.93,
    placement: 0.96,
    offer: 1
  }
  const stepMeta = {
    identity: ["About you", "Tell us a little about your work."],
    experience: ["Start here", "Answer a few questions to get your free sample."],
    volume: ["Weekly volume", "You’re almost ready to upload."],
    goal: ["Your sample goal", "Pick what matters most to you."],
    upload: ["Your design", "Add the design you want printed."],
    placement: ["Sample size", "Choose where you plan to press it."],
    offer: ["Your Press Test", "Choose one. Both include your artwork."]
  }

  const chicagoTimeZone = "America/Chicago"

  const chicagoDateParts = date => {
    const values = Object.fromEntries(new Intl.DateTimeFormat("en-US", {
      timeZone: chicagoTimeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23"
    }).formatToParts(date).filter(part => part.type !== "literal").map(part => [part.type, Number(part.value)]))
    return values
  }

  const calendarDate = ({ year, month, day }) => new Date(Date.UTC(year, month - 1, day, 12))

  const addCalendarDays = (date, count) => {
    const next = new Date(date)
    next.setUTCDate(next.getUTCDate() + count)
    return next
  }

  const addBusinessDays = (date, count) => {
    let next = new Date(date)
    let remaining = count
    while (remaining > 0) {
      next = addCalendarDays(next, 1)
      const day = next.getUTCDay()
      if (day !== 0 && day !== 6) remaining -= 1
    }
    return next
  }

  const formatDate = date => new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: "UTC"
  }).format(date)

  const formatWeekday = date => new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    timeZone: "UTC"
  }).format(date)

  const formatDateRange = (start, end) => `${formatDate(start)} to ${formatDate(end)}`

  const getShippingEstimate = now => {
    const parts = chicagoDateParts(now)
    const today = calendarDate(parts)
    const day = today.getUTCDay()
    const isShippingDay = day >= 1 && day <= 6
    const shipsToday = isShippingDay && parts.hour < 13
    let shipDate = today

    if (!shipsToday) {
      do {
        shipDate = addCalendarDays(shipDate, 1)
      } while (shipDate.getUTCDay() === 0)
    }

    const printsToday = day !== 0

    return {
      shipsToday,
      printsToday,
      printDate: printsToday ? today : shipDate,
      shipDate,
      deliveryStart: addBusinessDays(shipDate, 1),
      deliveryEnd: addBusinessDays(shipDate, 4)
    }
  }

  const init = root => {
    const card = root.querySelector(".dtfs-fs__card")
    const offerPanel = root.querySelector("[data-offer-panel]")
    const stage = root.querySelector("[data-stage]")
    const screens = Object.fromEntries(stepOrder.map(id => [id, root.querySelector(`[data-screen="${id}"]`)]))
    const progress = root.querySelector("[data-progress]")
    const stepLabel = root.querySelector("[data-step-label]")
    const engageCopy = root.querySelector("[data-engage-copy]")
    const entryGuide = root.querySelector("[data-entry-guide]")
    const volumeHeading = root.querySelector("[data-volume-heading]")
    const volumeOptions = root.querySelector("[data-volume-options]")
    const goalHeading = root.querySelector("[data-goal-heading]")
    const goalSupport = root.querySelector("[data-goal-support]")
    const goalOptions = root.querySelector("[data-goal-options]")
    const fileInput = root.querySelector("[data-file-input]")
    const dropzone = root.querySelector("[data-dropzone]")
    const uploadPreview = root.querySelector("[data-upload-preview]")
    const uploadPreviewArt = root.querySelector("[data-upload-preview-art]")
    const uploadChange = root.querySelector("[data-upload-change]")
    const fileName = root.querySelector("[data-file-name]")
    const uploadTitle = root.querySelector("[data-upload-title]")
    const uploadDetail = root.querySelector("[data-upload-detail]")
    const uploadIcon = root.querySelector("[data-upload-icon]")
    const uploadCheck = root.querySelector("[data-upload-check]")
    const uploadError = root.querySelector("[data-upload-error]")
    const uploadProgress = root.querySelector("[data-upload-progress]")
    const uploadProgressBar = root.querySelector("[data-upload-progressbar]")
    const uploadProgressFill = root.querySelector("[data-upload-progress-fill]")
    const uploadProgressStatus = root.querySelector("[data-upload-status]")
    const uploadProgressPercent = root.querySelector("[data-upload-percent]")
    const uploadContinue = root.querySelector("[data-upload-continue]")
    const uploadContinueLabel = root.querySelector("[data-upload-label]")
    const proofBridgeLabel = root.querySelector("[data-proof-bridge-label]")
    const proofBridgeQuote = root.querySelector("[data-proof-bridge-quote]")
    const proofBridgeReviewer = root.querySelector("[data-proof-bridge-reviewer]")
    const proofBridgeMeta = root.querySelector("[data-proof-bridge-meta]")
    const proofBridgeImage = root.querySelector("[data-proof-bridge-image]")
    const placementArtwork = root.querySelectorAll("[data-placement-art]")
    const shirtArtwork = root.querySelectorAll("[data-shirt-art]")
    const shirtArtworkGroups = root.querySelectorAll("[data-shirt-art-group]")
    const offerArt = root.querySelector("[data-offer-art]")
    const offerPlacement = root.querySelector("[data-offer-placement]")
    const creditChoice = root.querySelector("[data-credit-choice]")
    const offerChoiceButtons = [...root.querySelectorAll('[data-answer="offer"]')]
    const offerActionLabels = [...root.querySelectorAll("[data-offer-action]")]
    const offerBadges = root.querySelectorAll("[data-offer-badge]")
    const printLabelElement = root.querySelector("[data-print-label]")
    const shipLabelElement = root.querySelector("[data-ship-label]")
    const deliveryDateElement = root.querySelector("[data-delivery-date]")
    const checkoutStatus = root.querySelector("[data-checkout-status]")
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
    const storageKey = "dtfs-free-sample-funnel-v4"
    const funnelVersion = root.dataset.funnelVersion || "free-sample-v1"
    const backendBase = (root.dataset.backendBase || "").replace(/\/$/, "")
    const variantId = Number(root.dataset.variantId)
    const creditVariantId = Number(root.dataset.creditVariantId)
    const creditAvailable = Boolean(creditVariantId) && root.dataset.creditAvailable === "true"
    const creditBoostCheckoutEnabled = root.dataset.creditBoostCheckoutEnabled === "true"
    const zeroDollarCheckoutEnabled = root.dataset.zeroDollarCheckoutEnabled === "true"
    const searchParams = new URLSearchParams(window.location.search)
    const qaMode = searchParams.get("prototype_qa") === "1"
    const stored = (() => {
      try {
        return JSON.parse(window.sessionStorage.getItem(storageKey) || "{}")
      } catch {
        return {}
      }
    })()
    let sessionId = typeof stored.sessionId === "string" && /^[0-9a-f-]{36}$/i.test(stored.sessionId)
      ? stored.sessionId
      : window.crypto.randomUUID()
    const state = {
      current: "experience",
      answers: stored.answers && typeof stored.answers === "object" ? stored.answers : {},
      file: null,
      fileUrl: "",
      artworkId: typeof stored.artworkId === "string" ? stored.artworkId : "",
      artworkUrl: typeof stored.artworkUrl === "string" ? stored.artworkUrl : "",
      artworkFilename: typeof stored.artworkFilename === "string" ? stored.artworkFilename : "",
      transitioning: false
    }
    let arrivalTimer = 0
    let eventQueue = Promise.resolve()
    let funnelStarted = Object.keys(state.answers).length > 0
    let uploadSequence = 0
    let activeUploadRequest = null
    let uploadProgressFrame = 0
    let uploadProgressLastFrame = 0
    let uploadProgressValue = 0
    let uploadProgressGoal = 0
    let uploadProgressResponse = 900
    let uploadProgressStatusText = "Checking your file"
    let uploadProgressMode = "loading"
    let uploadProgressSettler = null
    let lastProofBridgeGoal = ""

    const qaNow = qaMode ? new Date(searchParams.get("prototype_now") || "") : null
    const estimate = getShippingEstimate(qaNow && !Number.isNaN(qaNow.getTime()) ? qaNow : new Date())
    const deliveryRange = formatDateRange(estimate.deliveryStart, estimate.deliveryEnd)
    const printWeekday = formatWeekday(estimate.printDate)
    const shipWeekday = formatWeekday(estimate.shipDate)
    printLabelElement.textContent = estimate.printsToday ? "Prints today" : `Prints ${printWeekday}`
    shipLabelElement.textContent = estimate.shipsToday ? "Ships today" : `Ships ${shipWeekday}`
    deliveryDateElement.textContent = deliveryRange

    const saveState = () => {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({
          sessionId,
          answers: state.answers,
          artworkId: state.artworkId,
          artworkUrl: state.artworkUrl,
          artworkFilename: state.artworkFilename
        }))
      } catch (error) {
        return error
      }
      return null
    }

    const attribution = (() => {
      const params = new URLSearchParams(window.location.search)
      const read = key => params.get(key)?.slice(0, 240) || null
      return {
        utmSource: read("utm_source"),
        utmMedium: read("utm_medium"),
        utmCampaign: read("utm_campaign"),
        utmContent: read("utm_content"),
        utmTerm: read("utm_term")
      }
    })()

    const track = (eventName, step = state.current, extra = {}) => {
      if (qaMode || !backendBase) return Promise.resolve(true)
      const payload = {
        eventId: window.crypto.randomUUID(),
        sessionId,
        eventName,
        step,
        funnelVersion,
        occurredAt: new Date().toISOString(),
        pageUrl: window.location.href,
        referrer: document.referrer || null,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        ...attribution,
        ...extra
      }
      eventQueue = eventQueue.then(async () => {
        try {
          const response = await fetch(`${backendBase}/api/free-sample/events`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            keepalive: true
          })
          return response.ok
        } catch {
          return false
        }
      })
      return eventQueue
    }

    const trackQuestion = (key, value) => {
      if (!funnelStarted) {
        funnelStarted = true
        track("sample_funnel_started", "experience")
      }
      track("sample_question_answered", state.current, { answerKey: key, answerValue: value })
      if (key === "experience") {
        track("sample_branch_selected", "experience", { properties: { branch: value } })
      }
    }

    const getStepOrder = () => stepOrder

    const getProgress = id => progressByStep[id]

    const updateChrome = id => {
      root.dataset.currentScreen = id
      progress.style.transform = `scaleX(${getProgress(id)})`
      stepLabel.textContent = stepMeta[id][0]
      engageCopy.textContent = stepMeta[id][1]
      entryGuide.hidden = id !== "experience"
    }

    const renderProofBridge = () => {
      if (!proofBridgeLabel || !proofBridgeQuote || !proofBridgeReviewer || !proofBridgeMeta || !proofBridgeImage) return
      const goal = state.answers.goal || "default"
      const proof = proofBridges[goal] || proofBridges.default
      proofBridgeLabel.textContent = proof.label
      proofBridgeQuote.textContent = proof.quote
      proofBridgeReviewer.textContent = proof.reviewer
      proofBridgeMeta.textContent = proof.meta
      proofBridgeImage.src = proof.image
      proofBridgeImage.alt = proof.alt
      proofBridgeImage.dataset.proofCrop = proof.imageCrop || ""
      if (lastProofBridgeGoal !== goal) {
        lastProofBridgeGoal = goal
        track("sample_proof_bridge_shown", "upload", { answerKey: "goal", answerValue: goal, properties: { reviewer: proof.reviewer, platform: "Judge.me" } })
      }
    }

    const markSelection = (key, value) => {
      root.querySelectorAll(`[data-answer="${key}"]`).forEach(button => {
        const selected = button.dataset.value === value
        button.classList.toggle("is-selected", selected)
        if (button.getAttribute("role") === "radio") {
          button.removeAttribute("aria-pressed")
          button.setAttribute("aria-checked", selected ? "true" : "false")
        } else {
          button.setAttribute("aria-pressed", selected ? "true" : "false")
        }
      })
    }

    const makeGoalOption = option => {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "dtfs-fs__option"
      button.dataset.answer = "goal"
      button.dataset.value = option[0]
      button.setAttribute("aria-pressed", "false")
      const radio = document.createElement("span")
      radio.className = "dtfs-fs__radio"
      radio.setAttribute("aria-hidden", "true")
      const copy = document.createElement("span")
      const strong = document.createElement("strong")
      strong.textContent = option[1]
      copy.append(strong)
      if (option[2]) {
        const small = document.createElement("small")
        small.textContent = option[2]
        copy.append(small)
      }
      button.append(radio, copy)
      return button
    }

    const renderGoal = () => {
      const set = goalSets[state.answers.experience] || goalSets.experienced
      goalHeading.textContent = set.heading
      goalSupport.textContent = set.support
      goalSupport.hidden = !set.support
      goalOptions.replaceChildren(...set.options.map(makeGoalOption))
      goalOptions.setAttribute("aria-label", set.heading)
      if (state.answers.goal) markSelection("goal", state.answers.goal)
    }

    const renderVolume = () => {
      const heading = state.answers.experience === "new"
        ? "About how many garments are you producing each week?"
        : "How many garments are you doing with DTF each week?"
      volumeHeading.textContent = heading
      volumeOptions.setAttribute("aria-label", heading)
    }

    const goalLabel = () => {
      const set = goalSets[state.answers.experience] || goalSets.experienced
      return set.options.find(option => option[0] === state.answers.goal)?.[1] || "Not answered"
    }

    const placementPreset = () => placementPresets[state.answers.placement] || null

    const recommendedOffer = () => {
      const isBusiness = state.answers.identity && state.answers.identity !== "other"
      const hasVolume = ["25-99", "100-249", "250-plus"].includes(state.answers.volume)
      return state.answers.experience === "experienced" && isBusiness && hasVolume ? "credit" : "free"
    }

    const artworkSource = () => state.fileUrl || state.artworkUrl

    const syncArtwork = () => {
      const source = artworkSource()
      if (!source) return
      uploadPreviewArt.src = source
      uploadPreview.hidden = false
      offerArt.src = source
      placementArtwork.forEach(image => image.setAttribute("href", source))
      shirtArtwork.forEach(image => image.setAttribute("href", source))
    }

    const renderPersonalizedPlacement = () => {
      const preset = placementPreset()
      if (!preset) return
      syncArtwork()
      shirtArtwork.forEach(image => {
        image.setAttribute("x", String(preset.preview.x))
        image.setAttribute("y", String(preset.preview.y))
        image.setAttribute("width", String(preset.preview.width))
        image.setAttribute("height", String(preset.preview.height))
      })
      shirtArtworkGroups.forEach(group => {
        if (preset.preview.transform) group.setAttribute("transform", preset.preview.transform)
        else group.removeAttribute("transform")
      })
      offerPlacement.textContent = `${preset.label} · ${preset.size}`
    }

    const renderOffer = () => {
      const recommendation = recommendedOffer()
      const recommendsCredit = recommendation === "credit"
      screens.offer.classList.toggle("is-credit-recommended", recommendsCredit)
      screens.offer.classList.toggle("is-free-recommended", !recommendsCredit)
      renderPersonalizedPlacement()
      offerBadges.forEach(badge => {
        const active = badge.dataset.offerBadge === recommendation
        badge.hidden = !active
        badge.closest("[data-answer='offer']")?.classList.toggle("is-recommended", active)
      })
      creditChoice.disabled = !creditAvailable
      if (!creditAvailable && state.answers.offer === "credit") delete state.answers.offer
      markSelection("offer", state.answers.offer || "")
      if (!creditAvailable) {
        creditChoice.querySelector(".dtfs-fs__offer-choice-foot strong").textContent = "Temporarily unavailable"
      }
    }

    const focusHeading = id => {
      window.requestAnimationFrame(() => screens[id].querySelector("h1, h2.fs-q")?.focus({ preventScroll: true }))
    }

    const animateEntry = async committed => {
      if (root.classList.contains("is-committed") === committed) return
      root.classList.add("is-entry-moving")
      const fromRect = card.getBoundingClientRect()

      if (reducedMotion.matches || typeof card.animate !== "function") {
        offerPanel.hidden = committed
        root.classList.toggle("is-committed", committed)
        root.classList.remove("is-entry-moving")
        return
      }

      const easing = "cubic-bezier(0.22, 1, 0.36, 1)"
      if (committed) {
        const offerExit = offerPanel.animate([
          { opacity: 1, transform: "translate3d(0,0,0)" },
          { opacity: 0, transform: "translate3d(-24px,0,0)" }
        ], { duration: 190, easing, fill: "both" })
        await Promise.allSettled([offerExit.finished])
        offerExit.cancel()
        offerPanel.hidden = true
        root.classList.add("is-committed")
        const toRect = card.getBoundingClientRect()
        const cardMove = card.animate([
          {
            transform: `translate3d(${fromRect.left - toRect.left}px,${fromRect.top - toRect.top}px,0) scale(${fromRect.width / toRect.width},${fromRect.height / toRect.height})`
          },
          { transform: "translate3d(0,0,0) scale(1,1)" }
        ], { duration: 420, easing, fill: "both" })
        await Promise.allSettled([cardMove.finished])
        cardMove.cancel()
      } else {
        offerPanel.hidden = false
        root.classList.remove("is-committed")
        const toRect = card.getBoundingClientRect()
        const cardMove = card.animate([
          {
            transform: `translate3d(${fromRect.left - toRect.left}px,${fromRect.top - toRect.top}px,0) scale(${fromRect.width / toRect.width},${fromRect.height / toRect.height})`
          },
          { transform: "translate3d(0,0,0) scale(1,1)" }
        ], { duration: 420, easing, fill: "both" })
        const offerEnter = offerPanel.animate([
          { opacity: 0, transform: "translate3d(-24px,0,0)" },
          { opacity: 1, transform: "translate3d(0,0,0)" }
        ], { duration: 340, delay: 90, easing, fill: "both" })
        await Promise.allSettled([cardMove.finished, offerEnter.finished])
        cardMove.cancel()
        offerEnter.cancel()
      }

      root.classList.remove("is-entry-moving")
      if (window.matchMedia("(max-width: 980px)").matches) {
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
    }

    const showImmediately = id => {
      stepOrder.forEach(screenId => {
        const active = screenId === id
        screens[screenId].hidden = !active
        screens[screenId].classList.toggle("is-active", active)
      })
      state.current = id
      updateChrome(id)
      stage.style.height = "auto"
      focusHeading(id)
    }

    const goTo = async id => {
      if (!screens[id] || id === state.current || state.transitioning) return
      if (id === "volume") renderVolume()
      if (id === "goal") renderGoal()
      if (id === "upload") renderProofBridge()
      if (id === "offer") renderOffer()
      state.transitioning = true
      const from = screens[state.current]
      const to = screens[id]
      const activeStepOrder = getStepOrder()
      const direction = activeStepOrder.indexOf(id) > activeStepOrder.indexOf(state.current) ? 1 : -1
      const fromHeight = from.offsetHeight
      stage.style.height = `${fromHeight}px`
      root.dataset.currentScreen = id
      to.hidden = false
      to.classList.add("is-transitioning")
      const toHeight = to.scrollHeight
      window.requestAnimationFrame(() => {
        stage.style.height = `${toHeight}px`
      })

      let screenTransition = Promise.resolve()
      if (!reducedMotion.matches && typeof to.animate === "function") {
        const easing = "cubic-bezier(0.22, 1, 0.36, 1)"
        const outgoing = from.animate([
          { opacity: 1, transform: "translate3d(0,0,0)" },
          { opacity: 0, transform: `translate3d(${-direction * 26}px,0,0)` }
        ], { duration: 280, easing, fill: "both" })
        const incoming = to.animate([
          { opacity: 0, transform: `translate3d(${direction * 34}px,0,0)` },
          { opacity: 1, transform: "translate3d(0,0,0)" }
        ], { duration: 360, easing, fill: "both" })
        screenTransition = Promise.allSettled([outgoing.finished, incoming.finished]).then(() => {
          outgoing.cancel()
          incoming.cancel()
        })
      }

      const entryTransition = animateEntry(id !== "experience")
      await Promise.allSettled([screenTransition, entryTransition])

      from.hidden = true
      from.classList.remove("is-active")
      to.classList.remove("is-transitioning")
      to.classList.add("is-active")
      state.current = id
      updateChrome(id)
      stage.style.height = "auto"
      state.transitioning = false
      focusHeading(id)
      if (direction > 0 && id === "offer") {
        track("sample_preview_shown", "offer")
        track("sample_offer_shown", "offer", { properties: { recommended_offer: recommendedOffer() } })
      }
    }

    const selectAnswer = button => {
      if (state.transitioning) return
      const key = button.dataset.answer
      const value = button.dataset.value
      state.answers[key] = value
      markSelection(key, value)
      trackQuestion(key, value)
      if (key === "experience") {
        delete state.answers.volume
        delete state.answers.goal
        delete state.answers.offer
        markSelection("volume", "")
        renderVolume()
        renderGoal()
      }
      if (["identity", "volume"].includes(key)) delete state.answers.offer
      saveState()
      if (key === "offer") {
        renderOffer()
        track("sample_offer_selected", "offer", { answerKey: "offer", answerValue: value, properties: { recommended_offer: recommendedOffer() } })
        startCheckout()
        return
      }
      const activeStepOrder = getStepOrder()
      const currentIndex = activeStepOrder.indexOf(state.current)
      window.setTimeout(() => goTo(activeStepOrder[currentIndex + 1]), 360)
    }

    const clearUploadError = () => {
      uploadError.hidden = true
      uploadError.textContent = ""
    }

    const paintUploadProgress = (value, status = uploadProgressStatusText, mode = uploadProgressMode) => {
      uploadProgressValue = Math.max(0, Math.min(100, value))
      uploadProgressStatusText = status
      uploadProgressMode = mode
      const progressValue = uploadProgressValue >= 100 ? 100 : Math.floor(uploadProgressValue)
      uploadProgress.hidden = false
      uploadProgress.classList.toggle("is-complete", mode === "complete")
      uploadProgress.classList.toggle("is-error", mode === "error")
      if (uploadProgressStatus.textContent !== status) uploadProgressStatus.textContent = status
      if (uploadProgressPercent.textContent !== `${progressValue}%`) uploadProgressPercent.textContent = `${progressValue}%`
      if (uploadProgressBar.getAttribute("aria-valuenow") !== String(progressValue)) {
        uploadProgressBar.setAttribute("aria-valuenow", String(progressValue))
      }
      uploadProgressBar.setAttribute("aria-valuetext", `${status}, ${progressValue}%`)
      uploadProgressFill.style.transform = `scaleX(${uploadProgressValue / 100})`
      if (qaMode) {
        window.__dtfsFreeSampleQaUploadLog ||= []
        window.__dtfsFreeSampleQaUploadLog.push({
          value: progressValue,
          rawValue: Number(uploadProgressValue.toFixed(3)),
          status,
          mode,
          at: Math.round(window.performance.now())
        })
      }
    }

    const settleUploadProgress = result => {
      if (!uploadProgressSettler) return
      const resolve = uploadProgressSettler
      uploadProgressSettler = null
      resolve(result)
    }

    const stopUploadProgressAnimation = result => {
      if (uploadProgressFrame) window.cancelAnimationFrame(uploadProgressFrame)
      uploadProgressFrame = 0
      uploadProgressLastFrame = 0
      settleUploadProgress(result)
    }

    const runUploadProgressAnimation = timestamp => {
      uploadProgressFrame = 0
      if (!uploadProgressLastFrame) uploadProgressLastFrame = timestamp
      const elapsed = Math.min(64, Math.max(0, timestamp - uploadProgressLastFrame))
      uploadProgressLastFrame = timestamp
      const distance = uploadProgressGoal - uploadProgressValue
      const snapDistance = uploadProgressGoal >= 100 ? 0.15 : 0.015
      const factor = 1 - Math.exp(-elapsed / uploadProgressResponse)
      const nextValue = distance <= snapDistance
        ? uploadProgressGoal
        : uploadProgressValue + distance * factor
      paintUploadProgress(nextValue)
      if (nextValue < uploadProgressGoal) {
        uploadProgressFrame = window.requestAnimationFrame(runUploadProgressAnimation)
        return
      }
      uploadProgressLastFrame = 0
      if (uploadProgressGoal >= 100) settleUploadProgress(true)
    }

    const setUploadProgressGoal = (value, status, response = 900, mode = "loading") => {
      uploadProgressGoal = Math.max(uploadProgressGoal, uploadProgressValue, Math.min(100, value))
      uploadProgressResponse = Math.max(80, response)
      uploadProgressStatusText = status
      uploadProgressMode = mode
      paintUploadProgress(uploadProgressValue, status, mode)
      if (reducedMotion.matches) {
        paintUploadProgress(uploadProgressGoal, status, mode)
        if (uploadProgressGoal >= 100) settleUploadProgress(true)
        return
      }
      if (!uploadProgressFrame && uploadProgressValue < uploadProgressGoal) {
        uploadProgressLastFrame = 0
        uploadProgressFrame = window.requestAnimationFrame(runUploadProgressAnimation)
      }
    }

    const resetUploadProgress = (hidden = true) => {
      stopUploadProgressAnimation(false)
      uploadProgressValue = 0
      uploadProgressGoal = 0
      uploadProgressResponse = 900
      uploadProgressStatusText = "Checking your file"
      uploadProgressMode = "loading"
      uploadProgress.hidden = hidden
      uploadProgress.classList.remove("is-complete", "is-error")
      uploadProgressStatus.textContent = "Checking your file"
      uploadProgressPercent.textContent = "0%"
      uploadProgressBar.setAttribute("aria-valuenow", "0")
      uploadProgressBar.setAttribute("aria-valuetext", "Checking your file, 0%")
      uploadProgressFill.style.transform = "scaleX(0)"
    }

    const beginUploadProgress = () => {
      resetUploadProgress(false)
      if (qaMode) window.__dtfsFreeSampleQaUploadLog = []
      paintUploadProgress(0, "Checking your file")
      setUploadProgressGoal(14, "Checking your file", 2400)
    }

    const finishUploadProgress = () => new Promise(resolve => {
      settleUploadProgress(false)
      uploadProgressSettler = resolve
      setUploadProgressGoal(100, "Saving artwork", qaMode ? 150 : 240)
    })

    const freezeUploadProgress = (status, mode) => {
      stopUploadProgressAnimation(false)
      uploadProgressGoal = uploadProgressValue
      paintUploadProgress(uploadProgressValue, status, mode)
    }

    const useFile = file => {
      clearUploadError()
      const allowedTypes = ["image/png", "image/jpeg", "image/webp"]
      if (!file || !allowedTypes.includes(file.type)) {
        uploadError.textContent = "Choose a PNG, JPG, or WEBP image."
        uploadError.hidden = false
        return
      }
      if (file.size > 25 * 1024 * 1024) {
        uploadError.textContent = "Choose an image smaller than 25 MB."
        uploadError.hidden = false
        return
      }
      uploadSequence += 1
      const sequence = uploadSequence
      if (activeUploadRequest) activeUploadRequest.abort()
      if (state.fileUrl) URL.revokeObjectURL(state.fileUrl)
      state.file = file
      state.fileUrl = URL.createObjectURL(file)
      state.artworkId = ""
      state.artworkUrl = ""
      state.artworkFilename = ""
      syncArtwork()
      fileName.textContent = file.name
      fileName.hidden = false
      uploadTitle.textContent = "Saving your artwork"
      uploadDetail.textContent = "Keep this tab open for a moment."
      uploadIcon.removeAttribute("hidden")
      uploadCheck.setAttribute("hidden", "")
      dropzone.classList.add("has-file", "is-uploading")
      dropzone.classList.remove("is-upload-error", "is-complete")
      uploadChange.hidden = false
      uploadContinue.disabled = true
      uploadContinue.hidden = true
      uploadContinue.classList.add("is-loading")
      uploadContinueLabel.textContent = "Choose where to print it"
      beginUploadProgress()
      saveState()
      window.requestAnimationFrame(() => {
        if (sequence === uploadSequence) uploadArtwork(sequence)
      })
    }

    const digestFile = async file => {
      const bytes = await file.arrayBuffer()
      const digest = await window.crypto.subtle.digest("SHA-256", bytes)
      return Array.from(new Uint8Array(digest)).map(value => value.toString(16).padStart(2, "0")).join("")
    }

    const readJson = async response => {
      try {
        return await response.json()
      } catch {
        return {}
      }
    }

    const sendUpload = (url, body, sequence) => new Promise((resolve, reject) => {
      const request = new XMLHttpRequest()
      activeUploadRequest = request
      request.open("POST", url)
      request.upload.addEventListener("progress", event => {
        if (sequence !== uploadSequence) return
        const ratio = event.lengthComputable && event.total > 0 ? event.loaded / event.total : 0.35
        setUploadProgressGoal(24 + ratio * 62, "Uploading artwork", 650)
      })
      request.addEventListener("load", () => {
        if (activeUploadRequest === request) activeUploadRequest = null
        if (request.status >= 200 && request.status < 300) resolve(true)
        else reject(new Error("The artwork file could not be uploaded."))
      })
      request.addEventListener("error", () => {
        if (activeUploadRequest === request) activeUploadRequest = null
        reject(new Error("The artwork file could not be uploaded."))
      })
      request.addEventListener("abort", () => {
        if (activeUploadRequest === request) activeUploadRequest = null
        reject(new DOMException("Upload replaced", "AbortError"))
      })
      request.send(body)
    })

    const finishUpload = async (completed, sequence) => {
      state.artworkId = completed.artworkId
      state.artworkUrl = completed.fileUrl
      state.artworkFilename = completed.filename || state.file.name
      saveState()
      const progressFinished = await finishUploadProgress()
      if (!progressFinished || sequence !== uploadSequence) return false
      paintUploadProgress(100, "Artwork saved", "complete")
      uploadTitle.textContent = "Your artwork is ready"
      uploadDetail.textContent = "We’ll use this exact file for your Press Test."
      uploadIcon.setAttribute("hidden", "")
      uploadCheck.removeAttribute("hidden")
      dropzone.classList.remove("is-uploading", "is-upload-error")
      dropzone.classList.add("is-complete")
      uploadContinue.disabled = false
      uploadContinue.hidden = false
      uploadContinue.classList.remove("is-loading")
      uploadContinueLabel.textContent = "Choose where to print it"
      track("sample_upload_completed", "upload", { properties: { artwork_id: state.artworkId } })
      return true
    }

    const uploadArtwork = async (sequence = uploadSequence) => {
      if (!state.file || sequence !== uploadSequence) return false
      if (state.artworkUrl) return true

      uploadContinue.disabled = true
      uploadContinue.hidden = true
      uploadContinue.classList.add("is-loading")
      uploadContinueLabel.textContent = "Choose where to print it"
      uploadTitle.textContent = "Saving your artwork"
      uploadDetail.textContent = "Keep this tab open for a moment."
      dropzone.classList.add("is-uploading")
      dropzone.classList.remove("is-upload-error", "is-complete")
      if (uploadProgressMode === "error") beginUploadProgress()
      setUploadProgressGoal(14, "Checking your file", 2400)
      clearUploadError()
      track("sample_upload_started", "upload", { properties: { mime_type: state.file.type, bytes: state.file.size } })

      try {
        if (qaMode) {
          await new Promise(resolve => window.setTimeout(resolve, 90))
          if (sequence !== uploadSequence) return false
          setUploadProgressGoal(38, "Uploading artwork", 430)
          await new Promise(resolve => window.setTimeout(resolve, 90))
          if (sequence !== uploadSequence) return false
          setUploadProgressGoal(82, "Uploading artwork", 430)
          await new Promise(resolve => window.setTimeout(resolve, 90))
          if (sequence !== uploadSequence) return false
          setUploadProgressGoal(97, "Saving artwork", 1200)
          await new Promise(resolve => window.setTimeout(resolve, 90))
          if (sequence !== uploadSequence) return false
          return finishUpload({ artworkId: window.crypto.randomUUID(), fileUrl: state.fileUrl, filename: state.file.name }, sequence)
        }

        if (!backendBase) throw new Error("Artwork service is unavailable.")

        const checksum = await digestFile(state.file)
        if (sequence !== uploadSequence) return false
        setUploadProgressGoal(18, "Checking your file", 1400)
        const stageResponse = await fetch(`${backendBase}/api/free-sample/uploads/stage`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sessionId,
            funnelVersion,
            filename: state.file.name,
            mimeType: state.file.type,
            bytes: state.file.size,
            checksum
          })
        })
        const stage = await readJson(stageResponse)
        if (sequence !== uploadSequence) return false
        if (!stageResponse.ok || !stage.artworkId || !stage.target) throw new Error(stage.error || "Could not prepare the artwork upload.")
        setUploadProgressGoal(24, "Starting upload", 700)

        const uploadBody = new FormData()
        stage.target.parameters.forEach(parameter => uploadBody.append(parameter.name, parameter.value))
        uploadBody.append("file", state.file, state.file.name)
        setUploadProgressGoal(28, "Uploading artwork", 900)
        await sendUpload(stage.target.url, uploadBody, sequence)
        if (sequence !== uploadSequence) return false
        setUploadProgressGoal(92, "Saving artwork", 1300)

        let completed = null
        for (let attempt = 0; attempt < 4; attempt += 1) {
          setUploadProgressGoal(94 + attempt * 1.5, "Saving artwork", 2600)
          const completeResponse = await fetch(`${backendBase}/api/free-sample/uploads/complete`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ sessionId, artworkId: stage.artworkId, funnelVersion })
          })
          completed = await readJson(completeResponse)
          if (sequence !== uploadSequence) return false
          if (completeResponse.ok && completed.fileUrl) break
          if (completeResponse.status !== 202) throw new Error(completed.error || "Could not save the artwork.")
          await new Promise(resolve => window.setTimeout(resolve, 1000 + attempt * 500))
        }
        if (!completed?.fileUrl) throw new Error("Artwork processing took too long. Please try again.")

        return finishUpload(completed, sequence)
      } catch (error) {
        if (sequence !== uploadSequence || error?.name === "AbortError") return false
        const message = error instanceof Error ? error.message : "Could not upload the artwork."
        uploadError.textContent = message
        uploadError.hidden = false
        uploadTitle.textContent = "Upload paused"
        uploadDetail.textContent = "Your artwork preview is still here. Try again."
        uploadIcon.removeAttribute("hidden")
        uploadCheck.setAttribute("hidden", "")
        dropzone.classList.remove("is-uploading")
        dropzone.classList.add("is-upload-error")
        freezeUploadProgress("Upload paused", "error")
        uploadContinue.disabled = false
        uploadContinue.hidden = false
        uploadContinue.classList.remove("is-loading")
        uploadContinueLabel.textContent = "Try uploading again"
        track("sample_upload_failed", "upload", { properties: { reason: message.slice(0, 200) } })
        return false
      }
    }

    const setCheckoutBusy = busy => {
      offerChoiceButtons.forEach(button => {
        button.disabled = busy || (button === creditChoice && !creditAvailable)
        button.classList.toggle("is-loading", busy && button.dataset.value === state.answers.offer)
      })
      offerActionLabels.forEach(label => {
        const selected = label.closest('[data-answer="offer"]')?.dataset.value === state.answers.offer
        label.textContent = busy && selected ? "Opening secure checkout..." : label.dataset.label
      })
    }

    const buildCheckoutPayload = () => {
      const preset = placementPreset()
      const sharedProperties = {
        "_Funnel version": funnelVersion,
        "_Start option": state.answers.offer === "credit" ? "$25 Credit Boost" : "Free Test",
        "_funnel_session_id": sessionId
      }
      const customTransferProperties = {
        "Sample item": "Custom artwork transfer",
        "Sample placement": preset.label,
        "Sample print size": preset.size,
        "_Sizing instruction": preset.instruction,
        "_Artwork file": state.artworkUrl,
        "_Artwork filename": state.artworkFilename,
        "_DTF experience": experienceLabels[state.answers.experience] || "Not answered",
        "_Business type": identityLabels[state.answers.identity] || "Not answered",
        "_Weekly garments": volumeLabels[state.answers.volume] || "Not answered",
        "_Sample goal": goalLabel(),
        ...sharedProperties,
        "_sample_component": "custom-transfer",
        "_artwork_id": state.artworkId,
        "_question_path": [state.answers.experience, state.answers.identity, state.answers.volume, state.answers.goal, state.answers.placement].filter(Boolean).join("|")
      }
      const sampleKitProperties = {
        "Sample item": "DTFSheet sample kit",
        ...sharedProperties,
        "_sample_component": "sample-kit"
      }
      const items = [
          { id: variantId, quantity: 1, properties: customTransferProperties },
          { id: variantId, quantity: 1, properties: sampleKitProperties }
        ]
      if (state.answers.offer === "credit") {
        items.push({
          id: creditVariantId,
          quantity: 1,
          properties: {
            "Offer": "$25 Credit Boost",
            "_Order credit": "$25",
            "_Earned bonus offer": "$25 after qualifying first $50+ DTF merchandise order",
            "_Qualification": "$50+ eligible DTF merchandise order",
            "_funnel_session_id": sessionId
          }
        })
      }
      return {
        items,
        attributes: {
          "Free sample funnel session": sessionId,
          "Free sample funnel version": funnelVersion,
          "Free sample start option": state.answers.offer === "credit" ? "25-credit-boost" : "free-test",
          "Acquisition offer mechanism": state.answers.offer === "credit" ? "25-credit-boost-v2" : "free-test-v2"
        }
      }
    }

    const startCheckout = async () => {
      checkoutStatus.hidden = true
      checkoutStatus.textContent = ""
      if (!variantId || !state.artworkUrl || !state.artworkId) {
        checkoutStatus.textContent = "Your artwork is not ready yet. Go back and upload it again."
        checkoutStatus.hidden = false
        return
      }
      if (!placementPreset()) {
        checkoutStatus.textContent = "Go back and choose what you want to sample so we know how to size your artwork."
        checkoutStatus.hidden = false
        return
      }
      if (!state.answers.offer) {
        checkoutStatus.textContent = "Go back and choose how you want to start."
        checkoutStatus.hidden = false
        return
      }
      if (state.answers.offer === "free" && !zeroDollarCheckoutEnabled && !qaMode) {
        checkoutStatus.textContent = "The $0 Free Test is being finalized. Checkout is not open yet."
        checkoutStatus.hidden = false
        return
      }
      if (state.answers.offer === "credit" && !creditAvailable) {
        checkoutStatus.textContent = "The order-credit option is temporarily unavailable. Choose the free sample instead."
        checkoutStatus.hidden = false
        return
      }
      if (state.answers.offer === "credit" && !creditBoostCheckoutEnabled && !qaMode) {
        checkoutStatus.textContent = "The $25 Credit Boost is being finalized. Checkout is not open yet."
        checkoutStatus.hidden = false
        return
      }
      const checkoutPayload = buildCheckoutPayload()
      if (qaMode) {
        window.__dtfsFreeSampleQaCheckout = checkoutPayload
        checkoutStatus.textContent = state.answers.offer === "credit"
          ? "Your Press Test and $25 order credit are ready for Shopify checkout."
          : "Your $0 custom sample and test kit are ready for Shopify checkout."
        checkoutStatus.hidden = false
        return
      }

      setCheckoutBusy(true)

      try {
        const cartRoot = window.Shopify?.routes?.root || "/"
        const addResponse = await fetch(`${cartRoot}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: checkoutPayload.items })
        })
        if (!addResponse.ok) throw new Error("Shopify could not add the sample to your cart.")
        const attributeResponse = await fetch(`${cartRoot}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: checkoutPayload.attributes })
        })
        if (!attributeResponse.ok) throw new Error("Shopify could not connect the sample to checkout.")
        await track("sample_checkout_started", "offer", { properties: { artwork_id: state.artworkId, cart_items: checkoutPayload.items.length, selected_offer: state.answers.offer } })
        window.location.assign(`${cartRoot}checkout`)
      } catch (error) {
        const message = error instanceof Error ? error.message : "Checkout could not be opened."
        checkoutStatus.textContent = `${message} Please try again.`
        checkoutStatus.hidden = false
        await track("sample_cart_failed", "offer", { properties: { reason: message.slice(0, 200) } })
        setCheckoutBusy(false)
      }
    }

    const highlightQuestion = () => {
      window.clearTimeout(arrivalTimer)
      card.classList.remove("is-cta-arrival")
      window.requestAnimationFrame(() => {
        card.classList.add("is-cta-arrival")
        arrivalTimer = window.setTimeout(() => card.classList.remove("is-cta-arrival"), 1600)
      })
    }

    const scrollToQuestion = () => {
      card.scrollIntoView({ behavior: reducedMotion.matches ? "auto" : "smooth", block: "start" })
      if (reducedMotion.matches) {
        highlightQuestion()
        return
      }
      const deadline = window.performance.now() + 6000
      const waitForArrival = () => {
        const top = card.getBoundingClientRect().top
        if ((top >= -4 && top <= 40) || window.performance.now() >= deadline) {
          highlightQuestion()
          return
        }
        window.requestAnimationFrame(waitForArrival)
      }
      window.requestAnimationFrame(waitForArrival)
    }

    root.addEventListener("click", event => {
      const proofSource = event.target.closest("[data-proof-source]")
      if (proofSource && root.contains(proofSource)) {
        track("sample_proof_source_clicked", state.current, { properties: { platform: proofSource.dataset.proofPlatform || "Unknown", goal: proofSource.dataset.proofGoal || state.answers.goal || null } })
        return
      }
      const checkout = event.target.closest("[data-checkout]")
      if (checkout && root.contains(checkout)) {
        startCheckout()
        return
      }
      const changeChoice = event.target.closest("[data-change-choice]")
      if (changeChoice && root.contains(changeChoice)) {
        goTo("offer")
        return
      }
      const funnelCta = event.target.closest("[data-funnel-cta]")
      if (funnelCta && root.contains(funnelCta)) {
        event.preventDefault()
        scrollToQuestion()
        return
      }
      const option = event.target.closest("[data-answer]")
      if (option && root.contains(option)) {
        selectAnswer(option)
        return
      }
      const back = event.target.closest("[data-back]")
      if (back && root.contains(back)) {
        const activeStepOrder = getStepOrder()
        const index = activeStepOrder.indexOf(state.current)
        if (index > 0) goTo(activeStepOrder[index - 1])
        return
      }
      const next = event.target.closest("[data-next]")
      if (next && root.contains(next)) {
        goTo(next.dataset.next)
      }
    })

    fileInput.addEventListener("click", () => {
      fileInput.value = ""
    })
    fileInput.addEventListener("change", () => useFile(fileInput.files?.[0]))

    ;["dragenter", "dragover"].forEach(type => {
      dropzone.addEventListener(type, event => {
        event.preventDefault()
        dropzone.classList.add("is-dragging")
      })
    })

    ;["dragleave", "drop"].forEach(type => {
      dropzone.addEventListener(type, event => {
        event.preventDefault()
        dropzone.classList.remove("is-dragging")
      })
    })

    dropzone.addEventListener("drop", event => useFile(event.dataTransfer?.files?.[0]))
    uploadContinue.addEventListener("click", async () => {
      if (!state.file && !state.artworkUrl) return
      if (!state.artworkUrl && !await uploadArtwork()) return
      goTo("placement")
    })

    const restoreUploadState = () => {
      if (!state.artworkUrl) return
      syncArtwork()
      fileName.textContent = state.artworkFilename || "Your artwork"
      fileName.hidden = false
      uploadTitle.textContent = "Your artwork is ready"
      uploadDetail.textContent = "We’ll use this exact file for your Press Test."
      uploadIcon.setAttribute("hidden", "")
      uploadCheck.removeAttribute("hidden")
      uploadChange.hidden = false
      dropzone.classList.add("has-file", "is-complete")
      dropzone.classList.remove("is-uploading", "is-upload-error")
      paintUploadProgress(100, "Artwork saved", "complete")
      uploadContinue.disabled = false
      uploadContinue.hidden = false
      uploadContinue.classList.remove("is-loading")
      uploadContinueLabel.textContent = "Choose where to print it"
    }

    renderGoal()
    syncArtwork()
    restoreUploadState()
    renderOffer()
    Object.entries(state.answers).forEach(([key, value]) => markSelection(key, value))
    updateChrome("experience")
    saveState()
    track("sample_funnel_viewed", "experience")
  }

  roots.forEach(init)
})()
